import React , { useCallback } from 'react';
import { useForm } from '~/hooks';
import { useSectionLoader } from '../../hooks';
import sectionTypes from '../sectionTypes';
import LienGrid from './LienGrid';
import { BsFillExclamationCircleFill } from 'react-icons/bs';

/**
 * @typedef LienReviewValues
 * @property {number}   sectionId
 * @property {string}   titleOpinionId * 
 * @typedef FormState
 * @property {LienReviewValues} values The current form values
 */

/** @type {LienReviewValues} */

const defaultState = {
    sectionId: 0
};

const LienReview = ({ titleOpinionId , validate , validationResult  }) => {

    const { onLoad: loadSection } = useSectionLoader(sectionTypes.LIENS, titleOpinionId);

    const onLoad = useCallback((values) => {
        return loadSection(values);
    }, [titleOpinionId]);

    const {
        /** @type {FormState} */
        state,
        fieldActions
    } = useForm({
        /** @type {ReviewValues} */
        initialState: { ...defaultState },
        onLoad,
        debug: true
    });

    let errorSection = false;
    if ( validate ) {        
        if(state.values.sectionId !== 0 && state.values.sectionDetails && state.values.sectionDetails.length > 0) {
            var errorArr = state.values.sectionDetails.filter(x => (x._data.lienType.label === '' || x._data.action.label === ''));
            if(errorArr.length > 0)
                errorSection = true;                
        }
        validationResult(errorSection);
    }

    return (
        
        <div className="ml-2 mr-5">
            {state.values.sectionId === 0 ? 
                <div />
                :
                <>
                    <div className="col-span-12 border-t-2 border-blueGray-30 mt-4 mb-4" />
                    <div className="text-1xl text-blue-60 font-bold mb-3">
                        <div className="display:flex; flex-direction:row;">
                            <div className="z-10 flex flex-row h-full  text-xs font-semibold text-blue-60">
                                <div className="mt-1 mb-2">5. <a href={`/StraightFinal/${titleOpinionId}/liens`}> Canceled/Previous Liens, Mortgages &amp; Deeds of Trust </a></div>
                            </div> 
                            
                        </div>
                    </div>
                    <div className="col-span-8 text-red-600 text-xs">
                        {errorSection ? 
                            <p className="flex flex-row gap-x-2 mb-2"><BsFillExclamationCircleFill />
                                You have not provided all the required information in this section.</p>
                            : ''
                        }
                    </div>
                    <div className="col-span-8 grid grid-cols-8 grid-flow-row gap-x-8 text-xs mb-4">
                        <LienGrid colSpan={12} fieldActions={fieldActions} titleOpinionId={titleOpinionId} sectionId={state.values.sectionId} sectionDetails={state.values.sectionDetails} editMode={false}/>
                    </div>
                </>
            }   
        </div>
    );
};

export default LienReview;